import React, { useRef } from "react";
import lock from "../../assets/images/lock.png";
import email from "../../assets/images/email.png";
import PasswordField from "../common/PasswordField";

export function LoginForm(props) {
	const instanceRef = useRef({ props });
	instanceRef.current.props = props;
	initialConstruct.bind(instanceRef.current)("LoginForm", props);

	const { validate, submit, setState: setParent, formref, store } = props;

	return (
		<form
			ref={formref}
			className="popuplogin"
			onSubmit={(e) => submit(e)}
		>
			<div className="title">Sign In</div>
			<div className="form-input">
				<img src={email} className="icon" />
				<input
					type="text"
					className="input"
					placeholder="Email Address"
					name="email"
					onChange={(e) => validate(e, "email", formref.current)}
					required
				/>
			</div>
			<div className="form-input">
				<img src={lock} className="icon" />
				<PasswordField
					className="input"
					placeholder="Password"
					name="password"
					required
				/>
			</div>
			<div className="form-input forgetpassword">
				<label
					className="label mousepointer"
					onClick={() => setParent({ form: "forgetpassword" })}
				>
					Forgot my password
				</label>
			</div>
			<div className="form-input">
				<span style={{ fontWeight: "bold", color: "red", fontSize: "10px" }}>
					{store.loginFaild}
				</span>
			</div>
			<div className="form-input">
				<button type="submit" className="button" id="signup">
					Sign In Now
				</button>
			</div>
			<div className="form-input">
				Don't have an account?&nbsp;{" "}
				<label
					className="customlable mousepointer"
					onClick={() => setParent({ form: "signup" })}
				>
					{" "}
					Sign Up Now
				</label>
			</div>
		</form>
	);
}

export default LoginForm;
